import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import { Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import DeleteTagButton from "./deleteTagButton";

const styles = theme => ({
  table: {
    minWidth: 700
  },
  fab: {
    margin: theme.spacing.unit
  },
  empty : {
    textAlign : 'center',
    padding   : 12,
  },
  bigAvatar : {
    margin : 4,
    width : 60,
    height : 60,
    borderRadius : 10,
  }
});

/**
 * Componente para renderizar el listado de tags
 * @author Jhoan López <jhoanlt19@gmail.com>
 */
class TagsTable extends Component {
  render() {
    const { classes, data=[], openEdit, query, client } = this.props;

    return (
      <React.Fragment>
        <Table className={classes.table} aria-labelledby="tags" size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Operaciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.tags && data.tags.length > 0 && data.tags
              .filter(row => !row.deleted)
              .map((row, key) => {
                return (
                  <TableRow key={key}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell component="th" scope="row" align="left">
                      {row.description}
                    </TableCell>
                    <TableCell align="right">
                      <Row>
                        <Col>
                          <Fab
                            size="small"
                            aria-label = "Edit"
                            className  = {classes.fab}
                            onClick    = {() => openEdit(row)}
                          >
                            <EditIcon />
                          </Fab>
                        </Col>
                        <Col>
                          <DeleteTagButton
                            row={row}
                            query={query}
                            client={client}
                          />
                        </Col>
                      </Row>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        {(!data.tags || data.tags.length === 0) &&
          <div className={classes.empty}><Typography variant="caption">¡No hay tags registrados!</Typography></div>
        }
      </React.Fragment>
    );
  }
}

TagsTable.propTypes = {
  classes  : PropTypes.object, 
  data     : PropTypes.object, 
  openEdit : PropTypes.func, 
  query    : PropTypes.object, 
}

export default withStyles(styles)(TagsTable);



// WEBPACK FOOTER //
// ./src/components/tags-manager/resources-tags/tagsTable.js